
import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getApplyToken, removeApplyToken ,getToken} from '@/utils/auth'
import { Loading } from 'element-ui';
export default class Service {
  constructor(baseURL, timeout) {
    this.requestCount = 0;
    this.baseURL = baseURL;
    this.timeout = timeout;
    this.service = axios.create({
      baseURL: this.baseURL,
      timeout: this.timeout
    })
  }  
  request() {
    this.service.interceptors.request.use(
      config => {
        this.config = config;
        this.requestCount++;
        if (config.loading === undefined) {
          this.config.loading = Loading.service({
            lock: false,
            spinner: 'logo',
            background: 'rgba(255, 255, 255, 0.8)',
          })
        } else {
          this.config.loading = Loading.service({
            lock: false,
            spinner: 'logo',
            background: 'rgba(255, 255, 255, 0.8)',
          })
        }
        // 正式
        
        // config.headers['Authorization'] = getApplyToken();

        // 测试
        config.headers['Authorization'] = getToken();
        return config
      },
      error => {
        this.config.loading.close();
        return Promise.reject(error)
      }
    )
    this.service.interceptors.response.use(
      response => {
        this.requestCount--;
        if (this.requestCount == 0) {
          this.config.loading.close();
        }
        const res = response.data
        
        if (res.code !== 200) {
          Message({
            message: res.msg || 'Error',
            type: 'error',
            duration: 5 * 1000
          })
    
          if (res.code === 500) {
            let msg = res.msg || '请求超时，请重试！'
            Message({
              message: msg,
              type: 'error',
              duration: 5 * 1000
            })
          }
    
    
          if (res.code == '401') {
            removeApplyToken()
            window.open(`https://tysfrzcs.tj.gov.cn/sso/login?client_id=N7S4UXW1J&utype=0&goto=${window.location.href}`, '_self')
          }
          return Promise.reject(new Error(res.message || 'Error'))
        } else {
          return res
        }
      },
      error => {
        this.requestCount--;
        if (this.requestCount == 0) {
          this.config.loading.close();
        }
        // Message({
        //   message: '网络超时,请重试！',
        //   type: 'error',
        //   duration: 5 * 1000
        // })
        return Promise.reject(error)
      }
    )
    return this.service
  }
}

